import { render, staticRenderFns } from "./StatesBuyMost.vue?vue&type=template&id=5072f36e&"
import script from "./StatesBuyMost.vue?vue&type=script&lang=js&"
export * from "./StatesBuyMost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports